export default "__VITE_PUBLIC_ASSET__bbcae32b__"